import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import { formatMagicLinkExpiry } from "Services/docForm.service";

const useStyles = makeStyles(() => ({
	banner: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "wrap",
		gap: 12,
		padding: "12px 16px",
		marginBottom: 12,
		backgroundColor: "#e8f4fd",
		border: "1px solid #006ac6",
		borderRadius: 8,
	},
	left: {
		display: "flex",
		alignItems: "flex-start",
		gap: 10,
		flex: 1,
		minWidth: 200,
	},
	plusIcon: {
		width: 24,
		height: 24,
		borderRadius: "50%",
		backgroundColor: "#006ac6",
		color: "#fff",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: 18,
		fontWeight: 700,
		flexShrink: 0,
		marginTop: 1,
	},
	textBlock: {
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	mainText: {
		fontSize: 14,
		color: "#004880",
		lineHeight: 1.4,
	},
	formLink: {
		color: "#006ac6",
		fontWeight: 600,
	},
	subText: {
		fontSize: 12,
		color: "#5a7a99",
	},
	button: {
		backgroundColor: "#006ac6",
		color: "#fff",
		textTransform: "none",
		"&:hover": { backgroundColor: "#0056a3" },
	},
}));

export default function MagicLinkInboxBanner({ formName, onOpenForm, actionLabel = "Open this form", tab = "Assigned" }) {
	const classes = useStyles();
	const expiryText = formatMagicLinkExpiry();
	if (!formName) return null;

	return (
		<div className={classes.banner} role="note">
			<div className={classes.left}>
				<div className={classes.plusIcon} aria-hidden>+</div>
				<div className={classes.textBlock}>
					<Typography className={classes.mainText}>
						<strong>From your email link:</strong>{" "}
						<span className={classes.formLink}>{formName}</span>
					</Typography>
					<Typography className={classes.subText}>
						Highlighted below under {tab}.
						{expiryText ? ` The link stays valid until ${expiryText}.` : ""}
					</Typography>
				</div>
			</div>
			{onOpenForm && (
				<Button
					variant="contained"
					className={classes.button}
					onClick={onOpenForm}
					size="small"
					startIcon={<EditIcon style={{ fontSize: 16 }} />}
				>
					{actionLabel}
				</Button>
			)}
		</div>
	);
}

const baseDataGridSx = {
	"& .MuiDataGrid-row": {
		backgroundColor: "#fff !important",
		"&:nth-of-type(even)": {
			backgroundColor: "#f9fafb !important",
		},
	},
	"& .magic-link-highlight-row": {
		backgroundColor: "#e8f4fd !important",
		boxShadow: "inset 3px 0 0 #006ac6",
	},
	"& .MuiDataGrid-cell": {
		padding: "8px 12px !important",
		fontSize: "14px",
		border: "none",
	},
	"& .MuiDataGrid-columnHeader": {
		borderRight: "none",
	},
	border: "none",
};

export const inboxDataGridSx = {
	...baseDataGridSx,
	"& .MuiDataGrid-columnHeaders": {
		backgroundColor: "#006ac6",
		color: "white",
		borderBottom: "none !important",
	},
	"& .MuiDataGrid-columnHeaderTitle": {
		fontWeight: 600,
		fontSize: "13px",
		letterSpacing: "0.04em",
		textTransform: "uppercase",
	},
};

export const quietDataGridSx = {
	...baseDataGridSx,
	"& .MuiDataGrid-columnHeaders": {
		backgroundColor: "#f9fafb",
		color: "#6b7280",
		borderBottom: "1px solid #e5e7eb !important",
	},
	"& .MuiDataGrid-columnHeaderTitle": {
		fontWeight: 600,
		fontSize: "12px",
		letterSpacing: "0.06em",
		textTransform: "uppercase",
		color: "#6b7280",
	},
};
